module.exports = __webpack_public_path__ + "img/355.c1f588b8.jpg";